<template>
<div class="authorize-protocol">
  <ucar-title>{{title}}</ucar-title>
  <div class="authorize-protocol-body">
    <h2>背景调查授权书</h2>
    <p class="b0">本人，<strong>{{name}}</strong>，身份证号：<strong>{{idCardNo}}</strong>。</p>
    <p class="b0">在此授权神州优车（福建）信息技术有限公司（以下简称“神州”）向依法成立的征信机构或其他调查机构对本人的背景信息进行全面核实，并承诺全力配合核实工作。本授权用于本人在申请入驻神州平台时作为招募条件进行背景核查，用于本人在神州平台运营期间，为保证网约车驾驶员的持续安全运营进行背景核查。</p>
    <p class="b0 bold">本人知悉，所涉及背景信息包括但不局限于：身份、住址、教育、就业、工作表现、诉讼记录、信用记录、驾驶历史、犯罪记录以及其它不良记录等相关信息。本人理解且认可神州对背景核实结果出具报告。</p>
    <p class="b0">本人同意并授权知悉或了解本人上述背景信息的个人、公司、机关、团体或者其他组织（以下合称“信息披露方”）配合神州的调查核实工作，如实披露有关信息或出具相关证明材料。<b>信息披露方的披露行为系经本人同意和授权，不构成对本人的侵权，本人不以任何形式追究信息披露方的责任。本人认可此授权书传真件、复印件、扫描件与原件具有同等效力，本人就上述调查所做的同意及授权自本授权书签署之日生效，本人在神州平台运营期间该授权均有效。</b></p>
    <p class="b0">本人知悉并同意神州将查询到的上述信息、调查核实结果用于：评估本人是否符合网约车司机的相关规定及神州平台的网约车司机要求。</p>
    <p>本人保证提供给神州的有关本人背景信息的内容真实、完整。本人理解并接受任何信息的隐瞒、伪造或遗漏可能会导致审核不通过。本人已知悉本授权书全部内容的含义及因此产生的法律效力，自愿同意作出以上授权（授权方式包括但不限于线下签字确认，电子签名、线上点击确认等数据电文形式）。<b>本授权书是本人的真实意思表示，本人一旦签署本授权书，即证明、声明和保证本人为所查询信息的主体，本人签署后本授权书即生效，本人同意承担由此带来的一切法律后果。</b></p>
    <ul>
      <li><b>授权人：</b><strong>{{name}}</strong></li>
      <li><b>姓名：</b><strong>{{name}}</strong></li>
      <li><b>身份证号：</b><strong>{{idCardNo}}</strong></li>
      <li><b>联系方式：</b><strong>{{mobile}}</strong></li>
      <li><b>日期：</b><strong>{{date}}</strong></li>
    </ul>
  </div>
</div>
</template>

<script>
import UcarDate from 'ucar-date'

export default {
  data () {
    return {
      title: '背景调查授权书',
      name: '',
      idCardNo: '',
      mobile: '',
      date: ''
    }
  },
  mounted () {
    this.mobile = this.vuexPersonMobile
    const { name, idCardNo } = this.vuexDriverInfo
    this.name = name
    this.idCardNo = idCardNo
    this.date = (new UcarDate()).dateStr
    console.log('this.vuexDriverInfo',this.vuexDriverInfo)
  }
}
</script>

<style lang="stylus" scoped>
@import "../../styles/variable.styl";

.authorize-protocol {

  .authorize-protocol-body {
    padding: 0 30px 30px;
  }

  h2,
  h3,
  h4 {
    text-align: center;
    font-weight: bold;
  }

  h2 {
    font-size: $ucar_font_h4;
    margin: 60px auto;
  }

  h3 {
    font-size: $ucar_font_h5;
    margin: 40px;
  }

  p {
    font-size: $ucar_font_h6;
    margin-bottom: 40px;
    line-height: 1.5;
    text-indent: 2em;

    &.bold{
     font-weight:bold;
    }
    &.b0{
      margin-bottom: 0;
    }
  }

  strong {
    text-decoration: underline;
  }

  ul {
    margin-top: 30px;
  }

  ul,
  ol {
    li {
      font-size: $ucar_font_h6;
      color: $ucar_font_color;
      line-height: 1.9;
    }
  }

  ul {
    li {
      text-indent: 0;
    }
  }
}
</style>
